export const SET_WIDTH_HEIGHT = 'SET_WIDTH_HEIGHT';

export const setWidthHeight = (width, height) => ({
  type: SET_WIDTH_HEIGHT,
  payload: { width, height },
});
